import linkEditingConstants from '../../link-editing/constants';

const {
  common: { LINK_CONFIG_ATTRIBUTE },
  linkTypes,
} = linkEditingConstants;

const injectSiteEmailsSettings = (options) => {
  const { settingValue, parsedElement } = options;
  const targetBlock = parsedElement.cloneNode(false);
  const emailElement = parsedElement.querySelector('a');

  settingValue.forEach((value) => {
    const newElement = emailElement ? emailElement.cloneNode(true) : document.createElement('a');
    const nodeWithText = newElement.querySelector('span') || newElement;
    const linkConfig = { linkType: linkTypes.MAIL, reference: value };

    newElement.setAttribute('href', '#');
    newElement.setAttribute(LINK_CONFIG_ATTRIBUTE, JSON.stringify(linkConfig));
    nodeWithText.innerText = value;

    targetBlock.appendChild(newElement);
  });

  return targetBlock.hasChildNodes() ? targetBlock : parsedElement;
};

export default injectSiteEmailsSettings;
